import { Grid, Typography } from "@mui/material";
import { AsyncSelect, ControlledDatePicker, ControlledTextField } from "src/components/forms";
import CardActions from "src/pages/sistema/components/CardActions";
import { OperacionWRCFields } from "../types/fields";
import { UseFormReturn } from "react-hook-form";
import { FormOperacionWRC } from "../types/types";
import { HttpCacheOperacion } from "src/pages/sistema/api/httpCacheOperacion";
import { OperacionWRC } from "../api";
import { dateFormatter } from "src/utils/formatters";
import { TextField } from 'src/lib/itaptec/components_forms/src'
import {SectorComercial, SectorComercialFields} from "../../../../../types";
import {useLoadOptions} from "../../../../../hooks/useLoadOptions";
import {useQuery} from "@tanstack/react-query";

const SchemaFields = OperacionWRCFields

type DatosOperacionProps = {
    formMethods: UseFormReturn<FormOperacionWRC>
    readOnly?: boolean
    operacion?: OperacionWRC
    codSistemaPrincipal: number
    codSistema: number
    nuevo?: boolean
}

const SeccionWRCDatosOperacion = ({ formMethods, readOnly, operacion, codSistemaPrincipal, codSistema, nuevo }: DatosOperacionProps) => {
    const { control, watch } = formMethods

    const sectoresHook = useQuery<SectorComercial[], Error>({
        queryKey: ['wrc-sectores-comerciales-grupo', codSistemaPrincipal, codSistema],
        queryFn: () => HttpCacheOperacion.getSectoresComercialesPorPaisSistemaGrupo(codSistemaPrincipal, codSistema),
        enabled: !!codSistemaPrincipal && !!codSistema
    })

    const loadSectoresComerciales = useLoadOptions({
        data: sectoresHook.data ?? [],
        loading: sectoresHook.isLoading,
        isError: sectoresHook.isError,
        error: sectoresHook.error
    });

    return (
        <CardActions title='Datos Operación' colapsable>
            <Grid container spacing={4}>
                {!nuevo && (
                    <Grid item xs={12} md={3}>
                        <Typography variant='body2'>Usuario Alta</Typography>
                        <Typography>
                            {operacion && `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}`}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <>
                            <Typography variant='body2'>Sector Comercial</Typography>
                            <Typography>{operacion?.nombreSectorComercial}</Typography>
                        </>
                    ) : (
                        <AsyncSelect
                            control={control}
                            name={SchemaFields.CodSectorComercial}
                            label='Sector Comercial'
                            loadOptions={loadSectoresComerciales}
                            valueField={SectorComercialFields.SectorComercialCodigo}
                            fullWidth
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <>
                            <Typography variant='body2'>Fecha Aprobación</Typography>
                            <Typography>{operacion && dateFormatter.toShortDate(operacion?.fechaEmision)}</Typography>
                        </>
                    ) : (
                        <ControlledDatePicker
                            name={SchemaFields.FechaEmision}
                            label='Fecha Aprobación'
                            control={control}
                            selectedSections={undefined}
                            fullWidth
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3}>
                    {readOnly ? (
                        <>
                            <Typography variant='body2'>Fecha Vencimiento</Typography>
                            <Typography>
                                {operacion && dateFormatter.toShortDate(operacion?.fechaVencimiento)}
                            </Typography>
                        </>
                    ) : (
                        <ControlledDatePicker
                            name={SchemaFields.FechaVencimiento}
                            label='Fecha Vencimiento'
                            control={control}
                            selectedSections={undefined}
                            minDate={watch(OperacionWRCFields.FechaEmision)}
                            fullWidth
                        />
                    )}
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ? (
                            <>
                                <Typography variant='caption'>Número Comitente </Typography>
                                <Typography>{operacion?.nroComitente}</Typography>
                            </>
                        ) : (
                            <TextField
                                name={SchemaFields.NroComitente}
                                label='Número Comitente'
                                control={control}
                                fullWidth
                                mask={{
                                    mask: Number
                                }}
                                size='small'
                            />
                        )
                    }
                </Grid>
                <Grid item xs={12} md={9}>
                    {readOnly ? (
                        <>
                            <Typography variant='caption'>Asesor Financiero</Typography>
                            <Typography>{operacion?.denominacionComitente}</Typography>
                        </>
                    ) : (
                        <TextField
                            name={SchemaFields.DenominacionComitente}
                            label='Asesor Financiero'
                            control={control}
                            fullWidth
                            mask={{
                                mask: /^[A-Za-z]+[A-Za-z ]*$/
                            }}
                            size='small'
                        />
                        )}
                </Grid>
                <Grid item xs={12}>
                    {readOnly ? (
                        <>
                            <Typography variant='caption'>Observaciones</Typography>
                            <Typography>{operacion?.observaciones}</Typography>
                        </>
                    ) : (
                        <ControlledTextField
                            name={SchemaFields.Observaciones}
                            label='Observaciones'
                            control={control}
                            multiline
                            rows={4}
                            fullWidth
                            size='small'
                        />
                    )}
                </Grid>
            </Grid>
        </CardActions>
    )
}

// TODO: sacarles "defaultValue" a ControlledComponents, porque deberían ser controlled justamente...

export default SeccionWRCDatosOperacion
